import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useRef, useState } from "react";
import { useUniqueId } from "../hooks/useUniqueId";
import { ArrowDownIcon } from "../icons/ArrowDownIcon";
import * as Styled from "./ExpandableContent.styled";
export const ExpandableContent = forwardRef((props, ref) => {
    const { children, defaultIsOpen, hasArrow, hasContentDivider, hasDivider, isOpen, renderToggle, onClick, onOpen, onClose, label, collapseLabel, expandLabel, ...otherProps } = props;
    const expandableId = useUniqueId("expandable-");
    const isFirstRun = useRef(true);
    const [isStateOpen, setIsStateOpen] = useState(defaultIsOpen);
    const toggleClick = (event) => {
        if (isOpen === undefined) {
            setIsStateOpen(!isStateOpen);
        }
        onClick && onClick(event, { isOpen: isStateOpen });
    };
    useEffect(() => {
        if (isFirstRun.current) {
            isFirstRun.current = false;
        }
        else {
            if (onOpen && (isStateOpen || isOpen)) {
                onOpen();
            }
            if (onClose && (isStateOpen === false || isOpen === false)) {
                onClose();
            }
        }
    }, [isOpen, isStateOpen, onClose, onOpen]);
    const isExpanded = isStateOpen === true || isOpen === true;
    return (_jsxs(Styled.ExpandableContent, { "data-testid": "ExpandableContent", ref: ref, hasDivider: hasDivider, ...otherProps, children: [renderToggle ? (renderToggle({
                isOpen: isExpanded,
                expandableId,
                toggleClick,
                onClick
            })) : (_jsxs(Styled.Toggle, { "aria-expanded": isExpanded, "aria-controls": `section-${expandableId}`, "data-testid": "ExpandableContentToggle", id: expandableId, isExpanded: isExpanded, onClick: toggleClick, children: [hasArrow && _jsx(ArrowDownIcon, { "aria-hidden": "true" }), _jsx("span", { children: label === undefined ? (isExpanded ? collapseLabel : expandLabel) : label })] })), typeof children === "function" ? (children({ isExpanded, expandableId })) : (_jsx(Styled.Content, { "aria-hidden": !isExpanded, isExpanded: isExpanded, id: `section-${expandableId}`, role: "region", "aria-labelledby": expandableId, hasContentDivider: hasContentDivider, children: children }))] }));
});
ExpandableContent.displayName = "ExpandableContent";
ExpandableContent.defaultProps = {
    defaultIsOpen: false,
    hasArrow: true,
    hasContentDivider: false,
    hasDivider: true
};
